import React from "react";

export const SubSectionTable = ({ children }) => {
    return <table className="spaced-subsection__table">{children}</table>;
};

export const SubSectionTableRow = ({ children }) => {
    return <tr>{children}</tr>;
};

export const SubSectionTableData = ({ children }) => {
    return <td>{children}</td>;
};

export const SubSectionTableColumn = ({ children }) => {
    return <th>{children}</th>;
};
